import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { GamevySpeedControl } from "../controls/gamevy-speed-control";

export class GamevySpeedControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return layer.getFlexiButton("gamevy_speed_1") != null &&
            layer.getFlexiButton("gamevy_speed_2") != null &&
            layer.getFlexiButton("gamevy_speed_3") != null;
    }

    public build(layer: Layers): AbstractControl[] {
        return [
            new GamevySpeedControl(
                layer.getFlexiButton("gamevy_speed_1"),
                layer.getFlexiButton("gamevy_speed_2"),
                layer.getFlexiButton("gamevy_speed_3")
            )
        ];
    }
}
